import call from "./call";

const Test = {
    test: () => call('Lu_XHSPfk_').then(res => console.log('testing', res))
};

export default Test;